let audioContext = null;

function getAudioContext() {
    if (typeof window === 'undefined') return;

    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;

    audioContext = audioContext || new AudioContext();
    return audioContext;
}

export function unlockHubtuneNotificationSound() {
    const context = getAudioContext();
    if (!context || context.state !== 'suspended') return;
    context.resume().catch((error) => {
        console.warn('Unable to unlock notification sound:', error);
    });
}

export async function playHubtuneNotificationSound() {
    const context = getAudioContext();
    if (!context) return;

    if (context.state === 'suspended') {
        try {
            await context.resume();
        } catch (error) {
            console.warn('Unable to resume notification sound:', error);
            return;
        }
    }

    const now = context.currentTime;
    const notes = [
        { frequency: 392.00, start: 0, duration: 0.16 },
        { frequency: 523.25, start: 0.12, duration: 0.18 },
        { frequency: 659.25, start: 0.26, duration: 0.32 },
    ];

    notes.forEach(({ frequency, start, duration }) => {
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.type = 'sine';
        oscillator.frequency.setValueAtTime(frequency, now + start);
        gain.gain.setValueAtTime(0.0001, now + start);
        gain.gain.exponentialRampToValueAtTime(0.12, now + start + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + start + duration);
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.start(now + start);
        oscillator.stop(now + start + duration + 0.02);
    });
}
